import { render, staticRenderFns } from "./ChannelPlugin.vue?vue&type=template&id=c968343a&"
import script from "./ChannelPlugin.vue?vue&type=script&lang=js&"
export * from "./ChannelPlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports